module.exports = __webpack_public_path__ + "img/alumni.632e7ea8.svg";